@if(!createReminder){

<div
  [ngStyle]="{
    height: !inlineComponent ? '650px' : 'auto',
    'max-height': !inlineComponent ? '90%' : 'auto',
  }"
  [ngClass]="inlineComponent ? 'custom-inline-component-reminder' : 'dialog-container-W750-H600'"
>
  @if(!inlineComponent){
  <div class="mb-3 flex justify-between">
    <p class="text-2xl font-bold" style="margin: 0px; position: relative; text-align: center; width: -webkit-fill-available; left: 12px">
      Manage Checklist
    </p>

    <button type="button" class="close add-close-button" style="position: relative; top: -6px" data-dismiss="modal" (click)="closeDialog()">
      <span style="font-size: 24px; font-weight: 600; color: #707070" class="material-icons icons-close-mobile">close</span>
    </button>
  </div>

  }

  <div
    [ngStyle]="{
      height: !inlineComponent ? 'calc(100% - 98px)' : '100%'
    }"
  >
    @if(!is_loading){

    <div class="flex justify-between items-center">
      <span [ngClass]="!inlineComponent ? '' : 'mt-1 mb-1'" style="justify-content: flex-start" class="text-sm text-[#18191C] font-semibold">
        Checklist Items
        <span class="font-bold text-[#25508e] ml-1" *ngIf="reminderList.length + linkedTasks?.length > 0">
          ({{ reminderList.length + linkedTasks?.length }})
        </span>
      </span>
      <button class="bg-[#25508E] cursor-pointer m-2 h-8 w-28 text-white rounded" (click)="addTask()">Add Task</button>
    </div>
    } @if ((reminderList.length || linkedTasks?.length ) == 0 && !is_loading ) { @if(inlineComponent ){
    <div style="max-height: 40%">
      <div
        [ngStyle]="{
          'margin-bottom': !inlineComponent ? '44px' : '0'
        }"
        class="border rounded-lg font-semibold mt-3 border-[#d3dce8] border-solid"
        style="padding: 14px 28px; text-align: center; margin-bottom: 24px"
      >
        <img class="mb-3 h-16" src="assets/images/cheecklist-zero-state.svg" />
        <p class="text-sm font-semibold text-center" style="margin: 6px">No <span class="font-bold" style="color: #25508e"> Items</span> to show</p>
      </div>
    </div>
    }@else{
    <div
      [ngStyle]="{
        'margin-bottom': !inlineComponent ? '44px' : '0'
      }"
      class="border rounded-lg font-semibold mt-3 border-[#d3dce8] border-solid"
      style="padding: 14px 28px; text-align: center"
    >
      <img class="mb-3 h-16" src="assets/images/cheecklist-zero-state.svg" />
      <p class="text-sm font-semibold text-center" style="margin: 6px">No <span class="font-bold" style="color: #25508e"> Items</span> to show</p>
    </div>
    } } @if ((reminderList.length || linkedTasks.length ) && !is_loading) { @if((reminderList.length || linkedTasks.length ) && !is_loading){
    <div [ngStyle]="{
      'height': (formatted_reminder_list | reminderSuggestionFilter : reminderList)?.length === 0 ? '90%' : '200px',
      'max-height': (formatted_reminder_list | reminderSuggestionFilter : reminderList)?.length === 0 ? '90%' : '200px'
    }" class="flex flex-col overflow-auto">

      @for (items of reminderList; track items; let i = $index) {
      <div
        class="flex justify-between border rounded border-[#e5e7eb]"
        [style.margin]="inlineComponent ? '12px 0px 12px 0px' : '12px 9px 12px 0px'"
        style="padding: 8px 0"
      >
        <div style="display: flex; margin-left: 6px; max-width: 100%">
          <span>
            <img src="assets/images/reminder-suggestion-icon.svg" />
          </span>
          <span>
            <p
              [ngClass]="items?.sub_title ? 'mt-2' : 'mt-4'"
              style="padding-left: 12px"
              class="text-truncate cursor-pointer text-sm font-semibold text-[#515765] mb-1"
              [matTooltip]="items.title | reminderTitleName : formValue : items"
            >
              {{ items.title | reminderTitleName : formValue : items }}
            </p>
            <p
              class="text-[10px] mb-1 text-[#707070] font-medium"
              [matTooltip]="items.sub_title | reminderTitleName : formValue : items"
              style="padding-left: 12px"
            >
              {{ items.sub_title | reminderTitleName : formValue : items }}
            </p>
          </span>
        </div>
        <button class="more-vote-btn" mat-icon-button [matMenuTriggerFor]="menuItem" [disableRipple]="true">
          <span class="material-icons">more_vert</span>
        </button>
        <mat-menu #menuItem="matMenu" yPosition="below" xPosition="before" class="small-width-menu popup-menu-panel">
          <!-- <button style="width: 185px" (click)="editReminder(items)" mat-menu-item class="text-[#000] leading-3 text-sm font-normal">
            <span style="position: relative; top: 4px" class="text-[#25508e] material-icons material-icons-round menuitem-icon">edit</span>
            Edit
          </button> -->
          <button (click)="deleteReminder(items)" mat-menu-item class="popup-menu-item custom-menu-bnt-upload text-[#ff0000]">
            <span class="material-icons menuitem-icon text-base text-[#ff0000]">delete</span>
            <span class="relative top-[-3px] left-[2px]"> Delete </span>
          </button>
        </mat-menu>
      </div>
      } @for(task of linkedTasks; track task){
      <div
        class="flex justify-between border rounded border-[#e5e7eb]"
        [style.margin]="inlineComponent ? '12px 0px 12px 0px' : '12px 9px 12px 0px'"
        style="padding: 8px 0"
      >
        <div style="display: flex; margin-left: 6px; max-width: 100%">
          <span>
            <img src="assets/images/checklist-task-icon.svg" />
          </span>
          <span>
            <p style="padding-left: 12px" class="text-truncate cursor-pointer text-sm font-semibold text-[#515765] mb-1 mt-4">
              {{ task.name }}
            </p>
            <!-- <p
              class="text-[10px] mb-1 text-[#707070] font-medium"
              style="padding-left: 12px"
            >
            We will remind you to renew or deactivate this before October 20, 2025
            </p> -->
          </span>
        </div>
        <button class="more-vote-btn" mat-icon-button [matMenuTriggerFor]="menuItem" [disableRipple]="true">
          <span class="material-icons">more_vert</span>
        </button>
        <mat-menu #menuItem="matMenu" yPosition="below" xPosition="before" class="small-width-menu popup-menu-panel">
          <button style="width: 185px" (click)="editTask(task)" mat-menu-item class="text-[#000] leading-3 text-sm font-normal">
            <span style="position: relative; top: 4px" class="text-[#25508e] material-icons material-icons-round menuitem-icon">edit</span>
            Edit
          </button>
          <button (click)="deleteTask(task)" mat-menu-item class="popup-menu-item custom-menu-bnt-upload text-[#ff0000]">
            <span class="material-icons menuitem-icon text-base text-[#ff0000]">delete</span>
            <span class="relative top-[-3px] left-[2px]"> Delete </span>
          </button>
        </mat-menu>
      </div>
      }
    </div>
    } }
    <div [ngStyle]="{ height: !inlineComponent ? (is_loading ? '100%' : '236px') : reminderList?.length == 0 ? '55%' : '50%' }" style="height: 236px">
      <reminder-suggestion
        [reminder_configurations_list]="reminder_configurations_list"
        [inlineComponent]="inlineComponent"
        [reminderList]="reminderList"
        [triggerTypeList]="triggerTypeList"
        [currentFormId]="currentFormId"
        [form_id]="form_id"
        [formValue]="formValue"
        (reminderLoadingDone)="reminderLoadingDone()"
        (createReminderEvent)="createReminderEvent()"
        (createReminderWithSuggestionEvent)="createReminderWithSuggestionEvent($event)"
        (formattedListChange)="onFormattedListChange($event)"
      >
      </reminder-suggestion>
    </div>
  </div>

  @if(!inlineComponent && !is_loading){
  <!-- <div class="action" style="text-align: start; border-top: 1px solid #d3dce8; margin: 12px 0px 0px 0px">
    <form class="text-center" [formGroup]="myForm">
      <mat-slide-toggle
        formControlName="name"
        style="margin: 18px 18px 0px 18px"
        class="font-normal text-[#515765] text-sm margin-zero"
        (change)="onToggleChange($event)"
      >
        All necessary items have been added to this template
      </mat-slide-toggle>
    </form>
  </div> -->
  }
</div>
}
